/**
 * @file Processor
 * @author Wim Haanstra
 */
import { DetailLevel } from './detail-level';
import { DayProcessor } from '../processors/day-processor';
import { WeekProcessor } from '../processors/week-processor';
import { MonthProcessor } from '../processors/month-processor';
import { QuarterProcessor } from '../processors/quarter-processor';
export var detailLevelQuarter = new DetailLevel('quarter', 'APP.HORIZON.QUARTER', 'quarter', 'isoWeek', 'months', 3, QuarterProcessor);
export var detailLevelMonth = new DetailLevel('month', 'APP.HORIZON.MONTH', 'month', 'isoWeek', 'month', 1, MonthProcessor);
export var detailLevelWeek = new DetailLevel('week', 'APP.HORIZON.WEEK', 'isoWeek', 'isoWeek', 'week', 1, WeekProcessor);
export var detailLevelDay = new DetailLevel('day', 'APP.HORIZON.DAY', 'day', 'day', 'day', 1, DayProcessor);
export var detailLevels = [
    detailLevelQuarter,
    detailLevelMonth,
    detailLevelWeek,
    detailLevelDay
];
export var detailLevelsNamed = {
    quarter: detailLevelQuarter,
    month: detailLevelMonth,
    week: detailLevelWeek,
    day: detailLevelDay
};
